import React from "react";
import { Button, message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Compressor from "compressorjs";

class AddPhoto extends React.Component {
  state = {
    fileList: [],
    uploading: false,
    isMobile: false, // Add isMobile state
  };

  // Per-instance refs so each record's buttons open its own file input.
  // (Previously shared DOM ids meant every button opened the first record's
  // input, so uploads always landed on the first record.)
  galleryInputRef = React.createRef();
  cameraInputRef = React.createRef();

  componentDidMount() {
    // Detect if it's a mobile device
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent.toLowerCase()
    );
    this.setState({ isMobile: mobile });
  }

  compressor = (image, callback) => {
    try {
      const quality =
        image.size >= 2000000 ? 0.1 : image.size >= 500000 ? 0.3 : image.size >= 200000 ? 0.5 : 0.8;
      new Compressor(image, {
        quality,
        success: (compressedResult) => {
          const file = new File([compressedResult], compressedResult.name || new Date().getTime() + ".jpeg", {
            type: compressedResult.type,
          });
          file["uid"] = image.uid || Date.now(); // Ensure unique UID
          callback(file);
        },
      });
    } catch (e) {
      console.error(`Image compress error - `, e);
      callback(image);
    }
  };

  handleUpload = () => {
    const { fileList } = this.state;
    this.setState({ uploading: true });
    const data = {
      _id: this.props.data._id,
      assetDetails: [
        {
          assetCode: this.props.data.assetCode,
          fileData: fileList,
        },
      ],
    };
    this.props.onUpload(data);
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      message.error("You can only upload image files!");
      return;
    }

    this.compressor(file, (compressedFile) => {
      this.setState(
        (prevState) => ({
          fileList: [...prevState.fileList, compressedFile],
        }),
        () => this.handleUpload()
      );
    });

    // Allow re-selecting the same file later.
    event.target.value = '';
  };

  handleRemove = (file) => {
    const { fileList } = this.state;
    const index = fileList.findIndex((f) => f.uid === file.uid);
    if (index !== -1) {
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      this.setState({ fileList: newFileList }, () => {
        this.handleUpload();
      });
    }
  };

  triggerFileInput = (ref) => {
    if (ref && ref.current) ref.current.click();
  };

  render() {
    const { uploading, fileList, isMobile } = this.state;

    return (
      <div className="document-upload">
        {/* Hidden file inputs */}
        <input
          type="file"
          ref={this.galleryInputRef}
          accept="image/*"
          style={{ display: "none" }}
          onChange={this.handleFileChange}
        />
        {isMobile && (
          <input
            type="file"
            ref={this.cameraInputRef}
            accept="image/*"
            capture="environment" // Camera option for mobile
            style={{ display: "none" }}
            onChange={this.handleFileChange}
          />
        )}

        {/* Buttons */}
        {isMobile ? (
          <div style={{ marginTop: 10 }}>
            <Button
              size="small"
              onClick={() => this.triggerFileInput(this.cameraInputRef)}
              disabled={this.props.isApproved}
              // loading={uploading}
              style={{ marginRight: 8 }}
            >
              Take Photo
            </Button>
            <Button
              size="small"
              onClick={() => this.triggerFileInput(this.galleryInputRef)}
              disabled={this.props.isApproved}
            // loading={uploading}
            >
              Choose from Gallery
            </Button>
          </div>
        ) : (
          <Button
            size="small"
            onClick={() => this.triggerFileInput(this.galleryInputRef)}
            disabled={this.props.isApproved}
          // loading={uploading}
          >
            Upload Photo
          </Button>
        )}

        {/* Display uploaded files */}
        {fileList.length > 0 && (
          <div style={{ marginTop: 16 }}>
            {fileList.map((file) => (
              <div key={file.uid} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                <span>{file.name}</span>
                <Button
                  type="link"
                  onClick={() => this.handleRemove(file)}
                  disabled={this.props.isApproved}
                  style={{ marginLeft: 8 }}
                >
                  Remove
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ commonData }) => {
  return {};
};

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps())(AddPhoto);

AddPhoto.propTypes = {
  data: PropTypes.object,
  onUpload: PropTypes.func,
  isApproved: PropTypes.bool,
};